import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  programGuideObject: {},
  programGuideList: [],
  careers: [],
  careerResult: {},
  showAllOccupations: false,
  programAlumniData: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./widgetSrc/app/programguide/vuex/index.js